export default __webpack_public_path__ + "static/media/login.8c1f5811.jpg";